import _ from "lodash";
import {
  ADD_ITEM_TO_PROGRESS_LIST,
  REMOVE_ITEM_FROM_PROGRESS_LIST,
  CLEAR_PROGRESS_LIST,
} from "../types";

export default function apiProgressList(state = {}, action = {}) {
  switch (action.type) {
    case ADD_ITEM_TO_PROGRESS_LIST: {
      let cancelSources = state.cancelSources;
      if (!cancelSources) cancelSources = [];
      cancelSources.push(action.cancelSourceData);
      return { ...state, cancelSources };
    }
    case REMOVE_ITEM_FROM_PROGRESS_LIST: {
      let cancelSources = state.cancelSources;
      if (!cancelSources) cancelSources = [];
      const itemIndex = _.findIndex(
        cancelSources,
        (cs) => cs.name === action.cancelSourceData.name
      );
      if (itemIndex > -1) {
        cancelSources.splice(itemIndex, 1);
      }
      return { ...state, cancelSources };
    }
    case CLEAR_PROGRESS_LIST: {
      return { ...state, cancelSources: [] };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/apiProgressList.js